import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-mapa-meta-buscar-form',
  standalone: false,
  templateUrl: './mapa-meta-buscar-form.component.html',
  styleUrls: ['./mapa-meta-buscar-form.component.scss']
})
export class MapaMetaBuscarFormComponent implements OnInit {

  @Input()
  categorias: any[];
  @Input()
  materias: any[];
  @Input()
  grados: any[];
  @Input()
  ambitos: any[];
  @Input()
  tags: any[];
  @Input()
  form: UntypedFormGroup;

  subCategorias = [];

  constructor() { }

  ngOnInit(): void {
    this.categorias.filter(item => item.ordenAgrupador === this.form.getRawValue().categorias[0]).forEach(categoria => {
      categoria.categorias.forEach(subCategoria => {
        if (this.subCategorias.findIndex(item => item.id === subCategoria.id) === -1) {
          this.subCategorias.push(subCategoria);
        }
      });
    });
  }

}
